import React, { Component } from 'react'
import '../../../node_modules/aos/dist/aos.css'; 
import AOS from 'aos'; 

export default class VCCustomAOSWrapper extends Component {
  constructor(props) { 
    super(props)
    AOS.init()
  }
  componentDidUpdate() { 
    AOS.refresh()
  }
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomAOSWrapper.js